import { useEffect, useState } from 'react';
import * as vp from 'vopay';
import { Link } from 'react-router-dom';
import { useBranding } from '../../providers/Branding.provider';
import styles from './LoginContainer.module.scss';
import useFetchLoginPageBranding from '@/hooks/useApi/useFetchLoginPageBranding';
import { Card } from 'UI';

type LoginContainerProps = {
  children: React.ReactNode;
};

const LoginContainer: React.FunctionComponent<LoginContainerProps> = ({ children }) => {
  const { Box, Icon } = vp;
  const [brandingLoaded, setBrandingLoaded] = useState(false);
  const { logo, setBrandingValues, setSsoProviders } = useBranding();
  const { fetchLoginPageBranding } = useFetchLoginPageBranding();

  useEffect(() => {
    initBranding();
  }, []);

  async function initBranding() {
    const res = await fetchLoginPageBranding();

    if (!res.Success) {
      console.warn(res.ErrorMessage);
    }

    setBrandingValues({
      primaryColor: res.BrandingDetails.PrimaryColor,
      secondaryColor: res.BrandingDetails.SecondaryColor,
      logo: res.Logo,
      appTitle: res.AppTitle,
      appFavicon: res.Favicon,
    });

    setSsoProviders(res.SSOProviders ?? {});

    setBrandingLoaded(true);
  }

  return (
    <div className={styles.loginContainer}>
      {brandingLoaded && (
        <Box flx="col" ai="center" jc="center">
          <Card className={styles.formContainer} hoverEffect={false}>
            {logo === '' && (
              <Link to={{ pathname: 'https://vopay.com' }} target="_blank">
                <div className={styles.logoContainer}>
                  <Icon icon="vLogoText" width="100%" height="100%" />
                </div>
              </Link>
            )}

            {logo !== '' && (
              <div className={styles.logoContainer}>
                <img
                  src={logo}
                  style={{
                    maxWidth: '175px',
                    maxHeight: '80px',
                    width: 'auto',
                    height: 'auto',
                    minHeight: '50px', // Prevents collapsing to 0x0
                    objectFit: 'contain',
                  }}
                  alt="Logo"
                />
              </div>
            )}

            {children}
          </Card>
        </Box>
      )}
    </div>
  );
};

export default LoginContainer;
